import { useState, type ReactNode } from 'react';

interface AccessButtonProps {
  label: string;
  color: string;
  icon: ReactNode;
  onClick: () => void;
}

export function AccessButton({ label, color, icon, onClick }: AccessButtonProps) {
  const [hov, setHov] = useState(false);
  const bg = hov ? `${color}24` : `${color}14`;
  const chipBg = hov ? `${color}33` : `${color}26`;

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => { setHov(true); }}
      onMouseLeave={() => { setHov(false); }}
      style={{
        flex: 1,
        border: 'none',
        borderRadius: 12,
        padding: '13px 18px',
        cursor: 'pointer',
        fontFamily: 'inherit',
        background: bg,
        color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        transition: 'background .18s ease',
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: chipBg,
          color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {icon}
      </div>
      <span style={{ fontSize: 12, fontWeight: 700 }}>{label}</span>
    </button>
  );
}
